import React from "react";
import "./ContactOptionStyles.css";

function ContactOptions({ icon, title, description }) {
  return (
    <div className="contact__option">
      <div className="left">{icon && icon}</div>
      <div className="right">
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
    </div>
  );
}

export default ContactOptions;
